import _Navbar from "@kibt/meta-ui/es/navbar";
import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { defineComponent, onMounted, onUnmounted, ref } from '@vue/composition-api';
import yoda from '@ks/yoda-js-sdk';
import { addShareParams } from '@/utils/share';
import { getBucket, kpn, lrpx2px } from '@/utils/device';
import { isInApp } from '@/utils/yoda';
import ProgressItem from '../sub-components/progress-item.vue';
import useStore from '../store';
export default defineComponent({
  components: {
    MNavbar: _Navbar,
    ProgressItem: ProgressItem
  },
  props: {
    type: {
      type: String,
      default: 'normal'
    }
  },
  setup: function setup(props, ctx) {
    var store = useStore();

    var handleClose = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(store.recentlyOpenedVenue && !store.postInMap[store.recentlyOpenedVenue.venueId] && store.activeVenueOpen)) {
                  _context.next = 6;
                  break;
                }

                store.changeGiftPopupVisible(false);
                store.changePostPopupVisible(true);
                store.recentlyOpenedVenue && store.setPostIn(store.recentlyOpenedVenue.venueId);
                _context.next = 9;
                break;

              case 6:
                _context.next = 8;
                return yoda.ready();

              case 8:
                yoda.webview.backOrClose();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleClose() {
        return _ref.apply(this, arguments);
      };
    }();

    var handleShare = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var url;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // sendTop100CustomLog({
                //     event: 'clickToShare',
                // });
                store.sendBlackCustomLog('clickToShare');
                store.sendClickLog('SHARE_BUTTON');
                url = new URL("".concat(window.location.origin, "/creator/black-month"));
                url.searchParams.set('kpn', kpn);
                url.searchParams.set('source', 'SHARE');
                url.searchParams.set('bizId', 'hideBar');
                url.searchParams.set('hyId', 'creator_top');
                url.searchParams.set('bucket', getBucket());
                addShareParams(url, 'creator_black_month');
                _context2.next = 11;
                return yoda.ready();

              case 11:
                _context2.next = 13;
                return yoda.component.selectShare({
                  param: {
                    type: 'link',
                    siteUrl: url.href,
                    needShorten: true,
                    caption: '#ParadaPreta No Kwai, ' + 'o evento que celebra de forma abrangente a riqueza e a diversidade da cultura negra no Brasil.'
                  }
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function handleShare() {
        return _ref2.apply(this, arguments);
      };
    }();

    var fixedShow = ref(false);

    var handleScroll = function handleScroll() {
      var scrollY = window.scrollY;
      fixedShow.value = scrollY >= lrpx2px(10);
    };

    onMounted(function () {
      window.addEventListener('scroll', handleScroll);
    });
    onUnmounted(function () {
      window.removeEventListener('scroll', handleScroll);
    });
    return {
      handleClose: handleClose,
      handleShare: handleShare,
      isInApp: isInApp,
      fixedShow: fixedShow,
      store: store
    };
  }
});